import { useState, useEffect } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase/firebaseConfig";

// Define a global cache for storing prices
const priceCache: { [key: string]: number } = {};

const useFetchPrice = (priceId: string) => {
  const [price, setPrice] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPrice = async () => {
      // Check if the price is already in the cache
      if (priceCache[priceId]) {
        setPrice(priceCache[priceId]);
        setLoading(false);
        return;
      }

      const functions = getFunctions(app, "us-central1");
      const getPriceDetails = httpsCallable(functions, "getPriceDetails");

      try {
        const result: any = await getPriceDetails({ priceId });
        if (result.data.success) {
          // Store the fetched price in the cache
          priceCache[priceId] = result.data.price;
          setPrice(result.data.price);
          setLoading(false);
        } else {
          throw new Error(result.data.error);
        }
      } catch (err: any) {
        setError(err.message || "Failed to fetch price");
        setLoading(false);
      }
    };

    if (priceId) {
      fetchPrice();
    }
  }, [priceId]); // Dependency array only includes priceId

  return { price, loading, error };
};

export default useFetchPrice;
